import type { CustomTheme } from '.'


export const customTheme: CustomTheme = {
  colors: {
    primary: {
      DEFAULT: '#C8017D',
      '50': '#FFE6F5',
      '100': '#FFB8E4',
      '200': '#FE8AD3',
      '300': '#FE5DC1',
      '400': '#FE2FB0',
      '500': '#C8017D',
      '600': '#BB016F',
      '700': '#98015F',
      '800': '#65013F',
      '900': '#330020',
    },
    gray: {
      DEFAULT: '#18305B',
      '50': '#F8F9FA',
      '100': '#F0F1F2',
      '200': '#E8E9EA',
      '300': '#E1E2E3',
      '400': '#D8D9DA',
      '500': '#0099FF',
      '600': '#007ACC',
      '700': '#005C99',
      '800': '#003D66',
      '900': '#001F33',
    },
    green: {
      '50': '#EDF8F0',
      '100': '#CCEBD5',
      '200': '#ABDDBB',
      '300': '#8BD0A0',
      '400': '#6AC385',
      '500': '#49B66B',
      '600': '#3A9255',
      '700': '#2C6D40',
      '800': '#1D492B',
      '900': '#0F2415',
    },
    blue: {
      '50': '#E5F8FF',
      '100': '#B8EBFF',
      '200': '#8ADEFF',
      '300': '#5CD1FF',
      '400': '#2EC4FF',
      '500': '#00B7FF',
      '600': '#0092CC',
      '700': '#006E99',
      '800': '#004966',
      '900': '#002533',
    },
    red: {
      '50': '#FEE7E7',
      '100': '#FCBBBB',
      '200': '#FA8F8F',
      '300': '#F76363',
      '400': '#F53838',
      '500': '#F30C0C',
      '600': '#C30909',
      '700': '#920707',
      '800': '#610505',
      '900': '#310202',
    },
  },
  semanticTokens: {
    colors: {
      'chakra-body-text': { _light: 'gray.800', _dark: 'whiteAlpha.900' },
      'chakra-body-bg': { _light: 'white', _dark: 'gray.800' },
      'chakra-border-color': { _light: 'gray.50', _dark: 'whiteAlpha.300' },
      // Badge
      'badge-bg': { default: 'gray.DEFAULT' },
      // Checkbox
      'checkbox-color': { default: 'gray.800' },
      'checkbox-border': { default: 'gray.500' },
      'checkbox-border-checked': { default: 'white' },
      'checkbox-shadow-color': { default: 'green.700' },
      'checkbox-shadow-highlight-color': { default: 'green.500' },
      // Dashboard
      'dashboard-header-bg':
        'linear-gradient(90.0deg, rgba(7, 3, 40, 1.0) 0%, rgba(0, 81, 135, 1.0) 100%)',
      // Form control
      'form-helper-text-color': { default: 'gray.800' },
      // Heading
      'heading-color': { default: 'gray.800' },
      // Input
      'input-bg': 'gray.50',
      'input-border': 'primary.600',
      'input-focused-border': 'primary.400',
      'input-color': 'gray.800',
      // Label
      'label-color': 'gray.800',
      // Menu
      'menu-item-color': 'gray.800',
      // Select
      'select-bg': 'gray.50',
      'select-border': 'gray.900',
      'select-color': 'gray.800',
      'select-icon-color': 'gray.500',
      // Text
      'text-color': 'gray.800',

      // Components
      // Steps
      'steps-container-bg': 'gray.800',
      'step-bg': 'gray.100',
      'step-number-border': 'gray.100',
      'step-number-bg': 'transparent',
      'step-number-color': 'gray.100',
      'step-number-passed-bg': 'gray.100',
      'step-number-passed-color': 'gray.800',
      'step-divider-bg': 'gray.600',
      'step-current-bg': 'gray.700',
      // Steps progress
      'step-progress-passed-bg': 'primary.DEFAULT',
      // Insurance Info Form Control
      'insurance-info-label-color': 'gray.100',
      'insurance-info-label-bg': 'gray.100',
      'insurance-info-value-color': 'gray.200',
      // Insurance Value
      'insurance-value-border': 'gray.300',
      // Wizzard header
      'wizzard-header-bg': 'gray.800',
      'wizzard-header-gap-bg':
        'linear-gradient(90.0deg, rgba(0, 163, 224, 1.0) 0%, rgba(198, 0, 126, 1.0) 100%)',
      'wizzard-header-history-timeline-dot-bg': 'gray.300',
      'wizzard-header-history-timeline-line-bg': 'gray.700',
      'wizzard-header-history-timeline-label-color': 'gray.200',
      'wizzard-header-history-timeline-user-color': 'gray.400',
      'wizzard-header-history-timeline-description-color': 'gray.200',
      'wizzard-header-history-scrollbar-thumb-color': 'gray.800',
      'wizzard-header-history-scrollbar-track-color': 'gray.600',

      'news-timeline-info-bg': 'blue.100',
      'news-timeline-info-fg': 'blue.600',
      'news-timeline-warn-bg': 'orange.200',
      'news-timeline-warn-fg': 'orange.600',
      'news-timeline-crit-bg': 'red.100',
      'news-timeline-crit-fg': 'red.600',

      'login-bg': 'linear-gradient(135.0deg, rgba(7, 3, 40, 1.0) 0%, rgba(0, 81, 135, 1.0) 100%)',
      'login-button-bg': 'primary.DEFAULT',
      'login-button-bg-hover': 'primary.600',
    },
  },
}
